"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WaysteAutopayCronResponse = exports.WaysteAutopayCronRequest = exports.AutopayRequestUpdate = exports.AutopayRequestQuery = exports.AutopayRequestCreate = exports.AutopayRequest = exports.AutopayAttempt = exports.AutopayStatus = exports.AutopayStatuses = void 0;
const typebox_1 = require("@sinclair/typebox");
const common_1 = require("../common");
// import { ReceivableTransport, WaysteReceivableTransport } from './receivable-transport';
exports.AutopayStatuses = ['PENDING', 'PROCESSING', 'COMPLETE', 'FAILED', 'CANCELLED'];
exports.AutopayStatus = typebox_1.Type.Union(exports.AutopayStatuses.map((status) => typebox_1.Type.Literal(status)));
// Stripe Source IDs are currently not included in these, intentionally. It's not a huge
// problem to reveal them, but I'm holding off on doing so until we have a good reason to.
exports.AutopayAttempt = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    timestamp: typebox_1.Type.String({ format: 'date-time' }),
    usedSourceID: typebox_1.Type.String(),
    attemptedChargeAmount: typebox_1.Type.Integer(),
    actualChargeAmount: typebox_1.Type.Integer(),
    failureReason: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.AutopayRequest = typebox_1.Type.Object({
    id: typebox_1.Type.String({ format: 'uuid' }),
    haulerID: typebox_1.Type.String({ format: 'uuid' }),
    // TODO: Remove this assuming it doesn't break anything.
    // receivable: Type.Optional(ReceivableTransport),
    // waysteReceivable: Type.Optional(WaysteReceivableTransport),
    status: exports.AutopayStatus,
    processOn: typebox_1.Type.String({ format: 'date' }),
    overridePaymentAmount: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    references: typebox_1.Type.Array(common_1.EntityReference),
    attempts: typebox_1.Type.Array(exports.AutopayAttempt),
    stripeSource: typebox_1.Type.String(),
    stripeCustomer: typebox_1.Type.String(),
    metadata: common_1.MetaData,
});
exports.AutopayRequestCreate = typebox_1.Type.Omit(exports.AutopayRequest, ['id', 'status', 'references', 'attempts', 'metadata']);
exports.AutopayRequestQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    status: typebox_1.Type.String(),
    processesBefore: typebox_1.Type.String({ format: 'date' }),
    processesAfter: typebox_1.Type.String({ format: 'date' }),
    receivableID: typebox_1.Type.String({ format: 'uuid' }),
    waysteReceivableID: typebox_1.Type.String({ format: 'uuid' }),
    referencesEntityType: common_1.EntityType,
    referencesEntityID: typebox_1.Type.String({ format: 'uuid' }),
    limit: typebox_1.Type.Integer({ minimum: 1 }),
    offset: typebox_1.Type.Integer({ minimum: 0 }),
}));
exports.AutopayRequestUpdate = typebox_1.Type.Partial(typebox_1.Type.Intersect([
    typebox_1.Type.Pick(exports.AutopayRequest, ['processOn', 'references', 'status', 'stripeSource', 'stripeCustomer']),
    typebox_1.Type.Object({
        overridePaymentAmount: typebox_1.Type.Optional((0, common_1.Nullable)(typebox_1.Type.Integer())),
    }),
]));
exports.WaysteAutopayCronRequest = typebox_1.Type.Optional(typebox_1.Type.Partial(typebox_1.Type.Object({
    autoPayIds: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
    date: typebox_1.Type.String({ format: 'date' }),
})));
exports.WaysteAutopayCronResponse = typebox_1.Type.Object({
    triggeredAutopayIds: typebox_1.Type.Array(typebox_1.Type.String({ format: 'uuid' })),
});
//# sourceMappingURL=autopay-request.js.map